import { Component } from 'react';
import PropTypes from 'prop-types';

class ScrollControl extends Component {
  componentDidUpdate() {
    if (this.props.scrollListener) {
      setTimeout(() => {
        document
          .querySelector(this.props.scrollLocation)
          .scrollIntoView({ block: 'start', behavior: 'smooth' });
      }, 1500);
    }
  }

  render() {
    return null;
  }
}

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
ScrollControl.displayName = 'ScrollControl';
// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
ScrollControl.propTypes = {
  scrollListener: PropTypes.bool,
  scrollLocation: PropTypes.string,
};

// eslint-disable-next-line react/static-property-placement -- directive added automatically by Shepherd migration
ScrollControl.displayName = 'ScrollControl';

export default ScrollControl;
